exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".example-container {\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    right: 0;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./ClientApp/app/components/app/app.component.css
// module id = 32
// module chunks = 4